import { useState } from "react"
import { X, ChevronLeft, ChevronRight } from "lucide-react"
import "../components/EventGallery.css";

const events = [
  {
    id: 1,
    title: "Product Launch Celebration",
    description: "Natoshine team celebrating the successful product launch with delegates at the welcome event",
    date: "November 2025",
    thumbnail: "/images/whatsapp-20image-202025-11-21-20at-2012.jpeg",
    images: [
      { id: "1-1", url: "/images/whatsapp-20image-202025-11-21-20at-2012.jpeg", caption: "Team with Natoshine banner" },
      { id: "1-2", url: "/images/whatsapp-20image-202025-11-21-20at-2012.jpeg", caption: "Welcome delegates" },
    ],
  },
  {
    id: 2,
    title: "Medical Seminar - Male Infertility",
    description: "Educational seminar on male factor infertility featuring clinical research and treatment options",
    date: "November 2025",
    thumbnail: "/images/whatsapp-20image-202025-11-21-20at-2012.jpeg",
    images: [
      {
        id: "2-1",
        url: "/images/whatsapp-20image-202025-11-21-20at-2012.jpeg",
        caption: "Presentation on male factor infertility",
      },
    ],
  },
  {
    id: 3,
    title: "Healthcare Conference 2025",
    description: "Large-scale pharmaceutical and healthcare conference with industry leaders and medical professionals",
    date: "November 2025",
    thumbnail: "/images/whatsapp-20image-202025-11-21-20at-2012.jpeg",
    images: [
      { id: "3-1", url: "/images/whatsapp-20image-202025-11-21-20at-2012.jpeg", caption: "Conference overview" },
      {
        id: "3-2",
        url: "/images/whatsapp-20image-202025-11-21-20at-2012.jpeg",
        caption: "Healthcare professionals networking",
      },
    ],
  },
]

export default function EventGallery() {
  const [selectedEvent, setSelectedEvent] = useState(null)
  const [currentImageIndex, setCurrentImageIndex] = useState(0)

  const handleNextImage = () => {
    if (selectedEvent) {
      setCurrentImageIndex((prev) => (prev + 1) % selectedEvent.images.length)
    }
  }

  const handlePrevImage = () => {
    if (selectedEvent) {
      setCurrentImageIndex((prev) => (prev - 1 + selectedEvent.images.length) % selectedEvent.images.length)
    }
  }

  return (
    <section className="event-gallery-section">
      <div className="event-gallery-container">
        <div className="event-gallery-header">
          <h2 className="event-gallery-title">Event Gallery</h2>
          <p className="event-gallery-subtitle">
            Celebrating our milestones, conferences, and community events
          </p>
        </div>

        <div className="event-grid">
          {events.map((event, index) => (
            <div
              key={event.id}
              className={`event-card
                ${index === 0 ? "event-card--large" : ""}
                ${index === 2 ? "event-card--tall" : ""}
              `}
              onClick={() => {
                setSelectedEvent(event)
                setCurrentImageIndex(0)
              }}
            >
              <div className="event-thumbnail-wrapper">
                <img
                  src={event.thumbnail || "/placeholder.svg"}
                  alt={event.title}
                  className="event-thumbnail"
                />
              </div>
              <div className="event-card-overlay">
                <h3 className="event-card-title">{event.title}</h3>
                <p className="event-card-date">{event.date}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedEvent && (
        <div
          className="modal-overlay"
          onClick={() => setSelectedEvent(null)}
        >
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setSelectedEvent(null)}
              className="modal-close-btn"
            >
              <X size={20} />
            </button>

            <div className="gallery-viewer">
              <div className="gallery-image-container">
                <img
                  src={selectedEvent.images[currentImageIndex]?.url || "/placeholder.svg"}
                  alt={selectedEvent.images[currentImageIndex]?.caption || "Event image"}
                  className="gallery-main-image"
                />
              </div>

              {selectedEvent.images.length > 1 && (
                <>
                  <button
                    onClick={handlePrevImage}
                    className="gallery-nav-btn gallery-nav-prev"
                  >
                    <ChevronLeft size={24} />
                  </button>
                  <button
                    onClick={handleNextImage}
                    className="gallery-nav-btn gallery-nav-next"
                  >
                    <ChevronRight size={24} />
                  </button>

                  <div className="gallery-counter">
                    {currentImageIndex + 1} / {selectedEvent.images.length}
                  </div>
                </>
              )}

              {selectedEvent.images[currentImageIndex]?.caption && (
                <div className="gallery-caption">
                  {selectedEvent.images[currentImageIndex].caption}
                </div>
              )}
            </div>

            <div className="modal-details">
              <h3 className="modal-title">{selectedEvent.title}</h3>
              <p className="modal-date">{selectedEvent.date}</p>
              <p className="modal-description">{selectedEvent.description}</p>

              {selectedEvent.images.length > 1 && (
                <div className="more-images-section">
                  <p className="more-images-title">More from this event</p>
                  <div className="thumbnails-row">
                    {selectedEvent.images.map((img, idx) => (
                      <button
                        key={img.id}
                        onClick={() => setCurrentImageIndex(idx)}
                        className={`thumbnail-btn ${
                          idx === currentImageIndex ? "active" : ""
                        }`}
                      >
                        <img
                          src={img.url || "/placeholder.svg"}
                          alt={`Thumbnail ${idx + 1}`}
                          className="thumbnail-btn-image"
                        />
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </section>
  )
}

